// Focus Visible Polyfill
import 'focus-visible'

// CSS
import './../css/main.css'

// Internal Modules
import scroll from './modules/scroll'
import timeline from './modules/timeline'
import carousel from './modules/carousel'

scroll()
timeline()
carousel()
